import React, { Fragment, useContext, useState, useEffect } from "react";
import { UserContext } from "./UserProvider";
import { auth, firebaseDb } from "./firebase";
import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";

const MainPage = () => {
  const user = useContext(UserContext);
  const { email } = user;
  const [gameList, setGameList] = useState([]);
  const postGame = firebaseDb.ref("games");

  const addGameClick = (event) => {
    event.preventDefault();

    let nameIn = document.getElementById("gameNameInput").value;
    let urlIn = document.getElementById("gameUrlInput").value;
    let imgIn = document.getElementById("gameImgInput").value;
    let oriType = document.getElementById("selectType").value;

    if (nameIn !== "" && urlIn !== "" && imgIn !== "") {
      const newGame = postGame.push();
      newGame
        .set({
          imgUrl: imgIn,
          name: nameIn,
          url: urlIn,
          orientation: oriType,
          isNew: "1",
          playCount: 0
        })
        .then((success) => {
          alertify.success("Kayıt Başarılı !");
          document.getElementById("gameNameInput").value = "";
          document.getElementById("gameUrlInput").value = "";
          document.getElementById("gameImgInput").value = "";

          let myArr = [];
          postGame
            .get()
            .then((data) => {
              if (data.exists()) {
                data.forEach((element) => {
                  const key = element.key;
                  const val = element.val();
                  myArr.push({ id: key, value: val });
                });
                setGameList(myArr);
              }
            })
            .catch((err) => {});
        })
        .catch((err) => {
          alertify.error("Kayıt Yapılamadı ! : ", err);
        });
    } else {
      alertify.error("Tüm Alanları Doldurman Gerekiyor !");
    }
  };

  useEffect(() => {
    (async () => {
      let myArr = [];
      const listener = postGame
        .get()
        .then((data) => {
          if (data.exists()) {
            data.forEach((element) => {
              const key = element.key;
              const val = element.val();
              myArr.push({ id: key, value: val });
            });
            setGameList(myArr);
          }
        })
        .catch((err) => {});
      return () => listener();
    })();
  }, []);

  const rowOnClick = (e) => {
    const gameId = e.target.parentElement.parentElement.firstChild.innerHTML;

    postGame
      .child(gameId)
      .remove()
      .then((suc) => {
        let myArr = [];
        postGame
          .get()
          .then((data) => {
            if (data.exists()) {
              data.forEach((element) => {
                const key = element.key;
                const val = element.val();
                myArr.push({ id: key, value: val });
              });
              setGameList(myArr);
            } else {
              setGameList([]);
            }
          })
          .catch((err) => {});
      })
      .catch((err) => {
        alertify.error("Hata Oyun Silinemedi !");
      });
  };

  const changeStatus = (e) => {
    const gameId = e.target.parentElement.parentElement.firstChild.innerHTML;

    postGame
      .child(gameId)
      .get()
      .then((data) => {
        if (data.exists()) {
         if(data.val().isNew == "0"){
            postGame.child(gameId).update({
              isNew: "1"
            })
            .then((success) => {
                alertify.success("Listeye eklendi !");
                let myArr = [];
                postGame
                  .get()
                  .then((data) => {
                    if (data.exists()) {
                      data.forEach((element) => {
                        const key = element.key;
                        const val = element.val();
                        myArr.push({ id: key, value: val });
                      });
                      setGameList(myArr);
                    } else {
                      setGameList([]);
                    }
                  })
                  .catch((err) => {});
            })
            .catch((err) => {
              alertify.error("Hata oluştu ! : ", err);
            });
         }else{
            postGame.child(gameId).update({
              isNew: "0"
            })
            .then((success) => {
                alertify.success("Listeden silindi !");
                let myArr = [];
                postGame
                  .get()
                  .then((data) => {
                    if (data.exists()) {
                      data.forEach((element) => {
                        const key = element.key;
                        const val = element.val();
                        myArr.push({ id: key, value: val });
                      });
                      setGameList(myArr);
                    } else {
                      setGameList([]);
                    }
                  })
                  .catch((err) => {});
            })
            .catch((err) => {
              alertify.error("Hata oluştu ! : ", err);
            });
         }
       }
      })
      .catch((err) => {
        alertify.error("Hata oluştu");
      });
    
  };

  return (
    <Fragment>
      <div className="user-info container rounded-3 my-5">
          <span>{email}</span><br/>
          <span className="logout-span"
            onClick={() => {
              auth.signOut();
            }}
          >
            Çıkış Yap
          </span>
      </div>

      <div className="container d-flex card border-0 shadow rounded-3 my-5">
          <span className="add-game-title bubblegum">Oyun Ekle</span>
          <form>
            <div className="form-group">
              <label htmlFor="gameNameInput">Oyun İsmi :</label>
              <input
                type="text"
                className="form-control"
                id="gameNameInput"
                placeholder="Oyun ismi"
              />
            </div>
            <div className="form-group">
              <label htmlFor="gameUrlInput">Oyun Url Adresi :</label>
              <input
                type="text"
                className="form-control"
                id="gameUrlInput"
                placeholder="Oyun Url Adresi"
              />
            </div>
            <div className="form-group">
              <label htmlFor="gameImgInput">Oyun Resim Adresi :</label>
              <input
                type="text"
                className="form-control"
                id="gameImgInput"
                placeholder="Oyun Resim Url"
              />
            </div>
            <div className="form-group">
              <label htmlFor="selectType">Ekran Tipi :</label>
              <select className="form-select input-select" id="selectType" defaultValue="0">
                <option value="0">Dikey</option>
                <option value="1">Yatay</option>
              </select>
            </div>

            <button
              type="button"
              className="btn btn-login m-0 mb-4"
              onClick={addGameClick}
            >
              Kaydet
            </button>
          </form>
      </div>

      <div className="container d-flex justify-content-around card border-0 shadow rounded-3 my-5">
          <span className="add-game-title bubblegum">Oyunlar</span>
          <div className="main-table">
            <table className="table table-responsive">
              <thead>
                <tr>
                  <th scope="col" className="hidden">#</th>
                  <th scope="col">Adı</th>
                  <th scope="col">Url</th>
                  <th scope="col">Resim Url</th>
                  <th scope="col">Ekran Tipi </th>
                  <th scope="col">Oynanma Sayısı</th>
                  <th scope="col">Yeni Listesi</th>
                  <th scope="col">Sil</th>
                </tr>
              </thead>
              <tbody>
                {gameList.length > 0 ? (
                  gameList.map((i) => (
                    <tr key={i.id}>
                      <td scope="row" className="hidden">{i.id}</td>
                      <td scope="row">{i.value.name}</td>
                      <td scope="row">{i.value.url}</td>
                      <td scope="row">{i.value.imgUrl}</td>
                      <td scope="row">
                        {i.value.orientation === "0" ? "Dikey" : "Yatay"}
                      </td>
                      <td scope="row">{i.value.playCount}</td>
                      <td scope="row">
                        {i.value.isNew === "1" ? <span className="span-btn red" onClick={changeStatus}>Çıkart</span> : <span className="span-btn green" onClick={changeStatus}>Ekle</span>}
                      </td>
                      <td scope="row">
                        <span className="span-btn red" onClick={rowOnClick}>
                          Sil
                        </span>

                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <th scope="row">Henüz oyun eklenmedi</th>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
      </div>



    </Fragment>
  );
};

export default MainPage;
